module.exports = __webpack_public_path__ + "static/img/3.58bed19.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/upload/commonality/20251009/3.jpg
// module id = K9fy
// module chunks = 7